import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import ClientStatusForm from "@components/dynamic/ClientStatusForm";

const ClientStatusIndex = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Estado de Cuenta"
      backUrl="/user/dashboard-accounting"
    >
      <h3>Seleccione un cliente para generar el estado de cuenta.</h3>
      <ClientStatusForm />

    </PageContainer >
  );
}

export default ClientStatusIndex;
